// basic len check for now
export const getValidUuidOrNull = possibleUuid => {
  return possibleUuid && possibleUuid.length === 36 ? possibleUuid : null;
};

export const isStrNullOrEmpty = str => str == null || str.trim() === '';

export const trimObjectKeys = (obj, keys) => {
  for (const key of keys) {
    if (key in obj && obj[key] != null) {
      obj[key] = obj[key].trim();
    }
  }
};

// Normalize a name for duplicate detection: lowercase, strip accents/diacritics
// and collapse all whitespace, so "John  Doe", "john doe" and "Jöhn Doe" all match.
export const normalizeName = value =>
  String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();

// A stable key identifying a participant by name, used to detect duplicates.
// Returns '' when both names are empty (nothing to compare against).
export const getNormalizedFullName = (firstName, lastName) => (normalizeName(firstName) + ' ' + normalizeName(lastName)).trim();
